import { TIERS } from './tiers'

/**
 * Application-wide constants.
 * Centralized location for magic numbers and configuration values.
 *
 * MOVED from src/constants/index.ts (Phase N-2)
 */

// Storage
export const STORAGE_KEY = 'meester_djay_v3'

/** Application display name — single source of truth */
export const APP_NAME = 'Meester djay'

/** Legacy storage key — used for one-time migration only */
export const LEGACY_STORAGE_KEY = 'cito_meester_djayden_v2'

// XP & Leveling
export const XP_PER_LEVEL = 250

// XP Rewards
export const XP_REWARDS = {
  CORRECT_HARD: 30,
  // Plus levels
  CORRECT_MEDIUM: 25,
  // Standard levels group 7/8
  CORRECT_EASY: 20,
  // Standard levels group 6
  EFFORT: 5, // Wrong answer (participation)
} as const

// Session Configuration
export const SESSION_CONFIG = {
  QUESTIONS_PER_SESSION: 10,
  RECENT_QUESTIONS_LIMIT: 25,
  // Increased from 15 to prevent loops in small pools
  CITO_QUESTION_COUNT: 30,
  CITO_TIME_LIMIT_SECONDS: 45 * 60, // 45 minutes
} as const

// Assessment Cooldown (per-group)
export const ASSESSMENT_COOLDOWN = {
  /** Minimum time between assessments for the same group (in milliseconds) */
  MIN_INTERVAL_MS: 60 * 60 * 1000, // 1 hour
  /** Human-readable label for the cooldown duration */
  LABEL: '1 uur',
} as const

// Mastery Thresholds (aligned with progressive mastery model)
export const MASTERY_THRESHOLDS = {
  MASTERED: 95,
  // Near-complete mastery of group content
  PRACTICED: 60,
  // Showing consistency
  LEARNING: 0, // Has started but not consistent
} as const

// Difficulty Labels (for display)
// Mapped from the centralized configuration
export const DIFFICULTY_LABELS: Record<number, string> = TIERS.reduce(
  (acc, tier) => {
    acc[tier.tier] = tier.levelCode
    return acc
  },
  {} as Record<number, string>,
)
